import { ThemeProvider } from '@/components/theme';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/context/AuthContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

interface AppProvidersProps {
  children: React.ReactNode;
  queryClient: QueryClient;
}

/**
 * AppProviders component - Centralized provider configuration
 * Following composition pattern and single responsibility principle
 * Makes testing easier by allowing provider injection
 */
export const AppProviders: React.FC<AppProvidersProps> = ({
  children,
  queryClient,
}) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider
        attribute='class'
        defaultTheme='system'
        enableSystem
        disableTransitionOnChange={false}
        storageKey='nova-user-theme'
      >
        <AuthProvider>
          <Router>
            {children}
            <Toaster />
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};
